module.exports = __webpack_public_path__ + "static/media/rsz_exitlimbowax.b6238bbc.webp";